import initialState from '../initialstate';
import * as types from "../../actions/actiontypes";

export function formatAssertionsForDisplayTaskWcgw(assertions) {
	let assertionsToUpdate = [];
	Object.assign(assertionsToUpdate, assertions);

	if (assertions && assertions.length > 0 && assertions.length < 5) {
		let assertionKnowledgeIds = assertionsToUpdate.map((a) => {
				return a.knowledgeAssertionId;
			}),
			emptyAssertion = {
				assertionName: '',
				assertionAbbreviation: '',
				accountId: 0,
				assertionId: 0,
				inherentRiskTypeId: 0,
				controlRiskTypeId: 0,
				hasRiskAssociated: false,
				accountName: null,
				knowledgeAssertionId: 6,
				craValue: '',
				validationStatus: null,
				validationMessages: null,
				displayOrder: 0,
				id: 0,
				notForDisplay: true
			};

		if (!assertionKnowledgeIds.some((v) => [6, 1, 10].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(0, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [7, 2, 11].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(1, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [8, 3, 12].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(2, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [4, 13].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(3, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [9, 5, 14].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(4, 0, emptyAssertion);
		}
	}
	return assertionsToUpdate;
}

export function wcgwReducer(state = initialState.wcgw, action){
	switch (action.type){
		case types.PUT_WCGW: {
			if (action.response) {
				let newState = {...state};
				newState.id = action.response.id;
				newState.wcgwName = action.response.wcgwName;
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}

export function wcgwsReducer(state = initialState.wcgws, action) {
	switch (action.type) {
		case types.GET_WCGWS: {
			return action.response || state;
		}
		default:
			return state;
	}
}